'use client';
import { flags } from '@mcdougald/env';
import { useQuery } from '@tanstack/react-query';
import { StarIcon } from 'lucide-react';

import Link from '@/components/link';
import { FOOTER_LINKS } from '@/constants/links';
import { useTRPC } from '@/trpc/client';

import { ProfileInformation } from '../../constants/data/profiles';
import { DynamicLink } from '../next/dynamic-link';

import NowPlaying from './now-playing';

function WebsiteCopyright() {
  return (
    <>
      {/*<h3 className="grid gap-1 font-serif font-semibold tracking-wide text-2xl h-fit">*/}
      {/*  {SITE_URL}*/}
      {/*</h3>*/}
      <p className="grid text-muted-foreground">
        © Trevor McDougald 2020-
        {new Date().getFullYear()}.
      </p>
    </>
  );
}

const ProfileAnchorLinks = () => {
  const totalProfiles = ProfileInformation.length;

  return (
    <div className={'flex flex-row h-fit flex-wrap gap-2 w-11/12'}>
      {ProfileInformation.map((prof, i) => {
        return (
          <div key={prof.displayName}>
            <DynamicLink
              href={prof.link}
              variant={'underline'}
              className={'text-blue-200'}
              // rel="noreferrer noopener"
              // target="_blank"
            >
              {prof.displayName}
            </DynamicLink>
            {i === totalProfiles - 1 ? '' : ', '}
          </div>
        );
      })}
    </div>
  );
};

const GithubLink = () => {
  const trpc = useTRPC();

  const { status, data } = useQuery(trpc.github.getRepoStars.queryOptions());

  return (
    <Link
      href="https://git.new/mcdougald"
      className="flex items-center justify-center overflow-hidden rounded-md border w-fit mt-auto mb-3"
    >
      <div className="bg-muted flex h-8 items-center gap-2 border-r px-2">
        <StarIcon className="size-4" />
        <span className="font-medium">Star</span>
      </div>
      <div className="bg-background flex h-8 items-center px-3">
        {status === 'pending' ? '--' : null}
        {status === 'error' ? 'Error' : null}
        {status === 'success'
          ? Intl.NumberFormat('en', {
              notation: 'compact',
              minimumFractionDigits: 0,
              maximumFractionDigits: 1,
            }).format(data)
          : null}
      </div>
    </Link>
  );
};

/**
 * Rendered in Default app/layout.tsx
 */
export function Footer() {
  return (
    <footer className={'mcdougald-footer bg-[#232427] min-h-[20vh] p-2 py-8'}>
      <section className="footer-section">
        <div className="container grid gap-12 md:grid-cols-[0.7fr_1fr] justify-self-center">
          <div className="grid md:grid-rows-[0.2fr_0.8fr]">
            {flags.spotify ? <NowPlaying /> : null}
            <GithubLink />
            <WebsiteCopyright />
          </div>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3">
            {FOOTER_LINKS.map((list) => (
              <div
                key={list.id}
                className="mb-10 flex flex-col items-start gap-4 pr-4"
              >
                {list.links.map((link) => {
                  const { href, key } = link;

                  return (
                    <Link
                      key={href}
                      href={href}
                      style={{ textTransform: 'capitalize' }}
                      className={
                        'text-muted-foreground hover:text-foreground transition-colors'
                      }
                    >
                      {key}
                    </Link>
                  );
                })}
              </div>
            ))}
          </div>
          {/*<div className="grid gap-6 min-w-1/2">*/}
          {/*  <h5 className="font-serif text-2xl tracking-wide font-semibold">*/}
          {/*    Connect*/}
          {/*  </h5>*/}
          {/*  <ProfileAnchorLinks />*/}
          {/*</div>*/}
        </div>
      </section>
    </footer>
  );
}
